<template>
  <div class="base">
    <inside-header back-link-name="UserSetting" color="#fff" title="个人信息" />
    <div class="main">
      <van-form input-align="right" @submit="onSubmit">
        <van-field label="会员身份" value="家长" readonly />
        <van-cell title="头像">
          <a-upload action="/api/index/file/uploadGeneralImage" name="image" :multiple="false" list-type="picture"
            :headers="headers" accept="image/png,image/jpeg" :file-list="headerFileList"
            @change="uploadHeadPortraitHandle">
            <a-button>
              <a-icon type="upload" /> 上传头像
            </a-button>
          </a-upload>
        </van-cell>
        <van-field v-model="info.nick_name" required name="nick_name" label="昵称" placeholder="请输入昵称"
          :rules="[{ required: true, message: '请输入昵称' }]" />
        <!-- v-model="username" -->
        <van-field v-model="info.sex" required clickable label="性别" name="sex"
          :rules="[{ required: true, message: '请输入性别' }]" @click="state.gender = true" />
        <van-popup v-model="state.gender" position="bottom">
          <van-picker show-toolbar :columns="['男', '女']" @confirm="onConfirm" @cancel="state.gender = false" />
        </van-popup>
        <!-- 位置设置 -->
        <van-field v-model="areaValue" required clickable name="area" label="地区选择" placeholder="点击选择省市区"
          @click="showArea = true" />
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showArea = false" />
        </van-popup>
        <van-field v-model="info.address" required label="地址" name="address" placeholder="请输入地址" />
        <div style="weight: 100%;height: 10px;background-color: #eee" />
        <!-- 第二块 -->
        <van-field name="switch" label="接受短信">
          <template #input>
            <van-switch v-model="sms_notice_status" active-color="#ff5c00" size="20" @change="smsNoticeStatusChange" />
          </template>
        </van-field>
        <van-field name="switch" label="接受短信">
          <template #input>
            <van-switch v-model="email_notice_status" active-color="#ff5c00" size="20"
              @change="emailNoticeStatusChange" />
          </template>
        </van-field>
        <van-field name="switch" label="接受短信">
          <template #input>
            <van-switch v-model="wx_notice_status" active-color="#ff5c00" size="20" @change="wxNoticeStatusChange" />
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block color="#ff5c00" type="info" :loading="state.submitBtn" native-type="submit">
            保存
          </van-button>
        </div>
      </van-form>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import AeraInfo from '@/assets/js/area.js'
import store from '@/store/'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      state: {
        gender: false,
        submitBtn: false
      },
      info: {
        nick_name: '',
        sex: '',
        address: '',
        province: '',
        city: '',
        area: ''
      },
      headers: {
        authorization: store.getters.token
      },
      // 头像列表
      headerFileList: [],
      header_img: null,
      headPortrait: [
        { url: '/uploads/images/20210113/bac20bea2f3b2ac6183262e044da261a.jpg' }
      ],
      header_resource_id: '',
      profile: {},
      realname: {},
      sms_notice_status: false,
      email_notice_status: false,
      wx_notice_status: false,
      showArea: false,
      areaValue: '',
      areaList: AeraInfo // 数据格式见 Area 组件文档
    }
  },
  watch: {
    areaValue(val) {
      var areaArr = val.split('/')
      this.info.province = areaArr[0]
      this.info.city = areaArr[1]
      this.info.area = areaArr[2]
    },
    profile(val) {
      this.info.nick_name = val.nick_name
      this.info.sex = val.sex
      this.info.province = val.province
      this.info.city = val.city
      this.info.area = val.area
      this.info.address = val.address
      this.areaValue = val.province + '/' + val.city + '/' + val.area
      this.sms_notice_status = val.sms_notice_status === 1
      this.email_notice_status = val.email_notice_status === 1
      this.wx_notice_status = val.wx_notice_status === 1
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      // 加载数据
      this.loading = true
      this.$http({
        url: '/index/user/profile',
        method: 'get',
        params: {}
      })
        .then(res => {
          this.loading = false
          if (res.status === 'success') {
            const data = res.data
            this.profile = data.profile
            this.realname = data.realname
          } else {
            this.$notification.error({
              message: '系统繁忙，请刷新重试',
              description: ''
            })
          }
        })
        .then(() => {
          this.$http({
            url: '/index/index/loadCity',
            method: 'get'
          }).then(res => {
            this.countryDivision = res.data
          })
        })
    },
    uploadHeadPortraitHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$message.success(`${e.file.name} 文件上传成功`)
          this.header_img = response.data
        } else {
          this.$message.error(
            `${e.file.name} 文件上传失败, 原因:` + response.message
          )
        }
      }
      const oneFileList = e.fileList.slice(-1)
      this.headerFileList = oneFileList
      this.header_resource_id = oneFileList[0].response.data.resource_id
    },
    onSubmit() {
      this.state.submitBtn = true
      var paramsData = this.info
      paramsData.header_resource_id = this.header_resource_id
      console.log(paramsData)
      this.$http({
        url: '/index/user/profileSave',
        method: 'post',
        data: paramsData
      }).then(res => {
        this.state.submitBtn = false
        if (res.status === 'success') {
          this.$toast.success('保存资料成功')
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    onConfirm(value) {
      this.info.sex = value
      this.state.gender = false
    },
    onAreaConfirm(values) {
      this.areaValue = values
        .filter(item => !!item)
        .map(item => item.name)
        .join('/')
      this.showArea = false
    },
    smsNoticeStatusChange(checked) {
      // 修改后台数据
      this.$http({
        url: '/index/user/changeSmsNoticeStatus',
        method: 'post',
        data: {
          sms_notice_status: checked
        }
      }).then(res => {
        if (res.status === 'success') {
          this.sms_notice_status = checked
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    emailNoticeStatusChange(checked) {
      // 修改后台数据
      this.$http({
        url: '/index/user/changeEmailNoticeStatus',
        method: 'post',
        data: {
          email_notice_status: checked
        }
      }).then(res => {
        if (res.status === 'success') {
          this.email_notice_status = checked
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    wxNoticeStatusChange(checked) {
      // 修改后台数据
      this.$http({
        url: '/index/user/changeWxNoticeStatus',
        method: 'post',
        data: {
          wx_notice_status: checked
        }
      }).then(res => {
        if (res.status === 'success') {
          this.wx_notice_status = checked
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;
}
</style>
